<template>
    <div class="-product-component-vars product-card">
        <!-- HEADER -->
        <div v-if="!isUnderOrEqualViewport768" class="product-card__header">
            <NuxtLink :to="linkProduct" :title="product.name">
                <h2 :title="product.name">{{ product.name }}</h2>
            </NuxtLink>
            <div class="product-card__header__price">
                <span :class="{ sale: isValidOldPrice }"
                    >{{ $t('globalTextAttributeCurrencySpecific') }} {{ product.price }}</span
                >
                <del v-if="product.oldPrice && isValidOldPrice"
                    >{{ $t('globalTextAttributeCurrencySpecific') }} {{ product.oldPrice }}</del
                >
            </div>
        </div>
        <!-- CONTENT -->
        <div class="product-card__content">
            <Badges class="product-card__content__badges" :badges="product.badges" />
            <div @click.stop class="product-card__content__vizualization">
                <div v-if="isSliderActive" :class="['product-card__content__vizualization__slider', 'swiper', sliderClass]">
                    <div class="swiper-wrapper">
                        <!-- ITEM -->
                        <NuxtLink
                            v-for="(slide, idx) in product.slides"
                            :key="idx"
                            :to="linkProduct"
                            class="product-card__content__vizualization__slider__item swiper-slide"
                        >
                            <img :src="slide.img" :alt="product.name" />
                        </NuxtLink>
                    </div>

                    <div :class="['product-card__content__vizualization__slider__pagination', sliderPaginationClass]"></div>
                </div>

                <NuxtLink v-else-if="haveImage" :to="linkProduct" class="product-card__content__vizualization__image">
                    <img :src="product?.img || firstSlideImage" :alt="product.name" />
                </NuxtLink>

                <NuxtLink v-else :to="linkProduct" class="product-card__content__vizualization__image">
                    <img
                        src="@/themes/novaporta/assets/images/placeholders/product-image-not-found.png"
                        alt="product-not-found"
                    />
                </NuxtLink>
            </div>
        </div>
        <!-- PANEL -->
        <div class="product-card__panel">
            <div class="product-card__panel__btn --favorite">
                <MyActionBtn
                    :class="{ liked: isInFavorites, transparent: true }"
                    :theme="'transparent-border'"
                    :size="btnSize"
                    :type="'icon'"
                    :icon="'likeIcon'"
                    @click="triggerActionFavorites()"
                />
            </div>
            <div class="product-card__panel__btn">
                <MyActionBtn
                    :theme="'default'"
                    :size="btnSize"
                    :type="'icon'"
                    :icon="'cartIcon'"
                    :disabled="!product.available"
                    @click="triggerActionAddToCart()"
                />
            </div>
        </div>
        <!-- FOOTER -->
        <div v-if="isUnderOrEqualViewport768" class="product-card__footer">
            <div class="product-card__footer__info">
                <NuxtLink :to="linkProduct" :title="product.name">
                    <h2 :title="product.name">{{ product.name }}</h2>
                </NuxtLink>

                <div class="product-card__footer__info__group">
                    <span :class="{ sale: isValidOldPrice }"
                        >{{ $t('globalTextAttributeCurrencySpecific') }} {{ product.price }}</span
                    >
                    <del v-if="product.oldPrice && isValidOldPrice"
                        >{{ $t('globalTextAttributeCurrencySpecific') }} {{ product.oldPrice }}</del
                    >
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import viewport from '~/mixins/viewport';
import slider from './../../mixins/slider';
import main from './../../mixins/main';

export default {
    name: 'Card',
    mixins: [main, viewport, slider],
    computed: {
        btnSize() {
            return this.isUnderOrEqualViewport768 ? 'small' : 'medium';
        }
    }
};
</script>

<style lang="scss" scoped>
@import './../../styles/context.scss';
@import './styles';
</style>
